<template>
  <div class="contentBox">
    <!-- 欢迎盒子 -->
    <WelcomeBox :flag="false" />
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 湖北省科技创新券总体兑付情况 -->
      <div class="imageBox">
        <div class="right">
          <div class="innovationVoucher">
            <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
            <span>湖北省科技创新券服务机构证书</span>
          </div>
          <div style="display: flex">
            <img src="@/assets/images/certi.jpg" width="370px" height="190px" alt="" />

            <div style="width: 370px; height: 190px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBox'
export default {
  components: {
    WelcomeBox
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.contentBox {
  width: 100%;
  height: 100%;
  .tableBox {
    margin-top: 25px;
  }
}
.innovationVoucher {
  font-weight: bold;
  display: flex;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;
  span {
    margin-left: 10px;
  }
}

.imageBox {
  display: flex;
  height: 250px;
  justify-content: space-between;
  // margin-bottom: 40px;
  img {
    cursor: pointer;
  }
  .left {
    img {
      margin: 0 10px;
    }
  }
  .right {
    flex: 1;
    img {
      margin: 0 9.5px;
    }
  }
}
</style>
